var map = {
	"./events/cadd-modelling-thumb.jpg": "1796",
	"./events/cadd-modelling.jpg": "4778",
	"./events/carrom-thumb.jpg": "6d16",
	"./events/carrom.jpg": "e92a",
	"./events/connexion-thumb.jpg": "c408",
	"./events/connexion.jpg": "f54b",
	"./events/cricket-thumb.jpg": "b474",
	"./events/cricket.jpg": "fa39",
	"./events/football-thumb.jpg": "ccb6",
	"./events/football.jpg": "d550",
	"./events/hydro-rocketry-thumb.jpg": "450d",
	"./events/hydro-rocketry.jpg": "6fe4",
	"./events/ipl-auction-thumb.jpg": "315e",
	"./events/ipl-auction.jpg": "bcc9",
	"./events/machinist-thumb.jpg": "e1a5",
	"./events/machinist.jpg": "09da",
	"./events/memecreation-thumb.jpg": "2c32",
	"./events/memecreation.jpg": "c670",
	"./events/mrmechanic-thumb.jpg": "f580",
	"./events/mrmechanic.jpg": "ffd5",
	"./events/paper-presentation-thumb.jpg": "edc2",
	"./events/paper-presentation.jpg": "fdb8",
	"./events/photography-thumb.jpg": "e5f6",
	"./events/photography.jpg": "971f",
	"./events/pubg-thumb.jpg": "9211",
	"./events/pubg.jpg": "5605",
	"./events/rc-racing-thumb.jpg": "8e10",
	"./events/rc-racing.jpg": "8a16",
	"./events/short-film-thumb.jpg": "b0ad",
	"./events/short-film.jpg": "4608",
	"./events/technical-catechize-thumb.jpg": "5acc",
	"./events/technical-catechize.jpg": "e4d9",
	"./events/tiktok-thumb.jpg": "e2ad",
	"./events/tiktok.jpg": "d815",
	"./facebook.svg": "aaa3",
	"./instagram.svg": "54e6",
	"./logo.jpg": "b640",
	"./menu_events_48.png": "0967",
	"./menu_home_48.png": "2ce2",
	"./menu_register_48.png": "b467",
	"./twitter.svg": "a3df"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";